import { mapState, mapActions, mapGetters } from 'vuex';
import { lockModal, unLockModal } from '@/utils/helpers';

export default {
  computed: {
    ...mapGetters('browse', ['userBrowseHeaders']),
    ...mapState('browse', ['showNavBrowseOverlay']),
  },
  methods: {
    ...mapActions('browse', ['closeNavBrowseCategoriesOverlay']),
    closeOverlay() {
      this.closeNavBrowseCategoriesOverlay();
    },
  },
  watch: {
    showNavBrowseOverlay(value) {
      if (value) {
        lockModal();
      } else {
        unLockModal();
      }
    },
  },
};
